import { Button } from '@components/Button'
import { Icon } from '@components/Icon'
import { Modal } from '@components/Modal'
import { Typography } from '@components/Typography'
import styled from 'styled-components'
import FrownIcon from '../../assets/icons/frown.svg'

export const Divider = styled.div`
  width: 90%;
  border: solid 0.6px #bdbdbd;
  margin: auto;
  margin-top: 24px;
`

export const StyledFrownIcon = styled(Icon).attrs({
  src: FrownIcon,
  className: 'intake__icon-frown',
})`
  margin-bottom: 30px;
`

export const StyledSecurityInfo = styled(Typography)`
  font-size: 12px;
  font-weight: 200;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  color: #777777;
`
export const StyledNeedHelp = styled(Typography)`
  font-size: 14px;
  font-weight: 200;
`
export const StyledBackToTheForm = styled(Button)`
  margin: 40px 0;
`

export const StyledModalTitle = styled(Modal.Title)`
  display: flex;
  align-items: center;
  flex-direction: column;
`
